import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCatOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [mobileOpen]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled || mobileOpen
            ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
            : "bg-transparent"
        }`}
      >
        <div className="px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 group cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-950 whitespace-nowrap">
                Yoybuy Sheet
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className={`flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === "/"
                    ? "bg-primary-50 text-primary-600"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                }`}
              >
                <i className="ri-home-line"></i>
                Главная
              </Link>
              <Link
                to="/yoybuy-spreadsheet-guide"
                className={`flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === "/yoybuy-spreadsheet-guide"
                    ? "bg-primary-50 text-primary-600"
                    : "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                }`}
              >
                <i className="ri-book-open-line"></i>
                Руководство
              </Link>
            </div>

            <div className="flex items-center gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="hidden sm:flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-cart-line"></i>
                Купить сейчас
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="hidden sm:flex items-center gap-1.5 px-4 py-2 rounded-full border-2 border-primary-500 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-external-link-line"></i>
                Yoybuy Sheet
              </a>

              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="Меню"
              >
                <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMobileOpen(false)}></div>
          <div className="absolute top-16 left-0 right-0 bottom-0 bg-background-50 overflow-y-auto">
            <div className="p-4 space-y-2">
              <Link
                to="/"
                className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === "/" ? "bg-primary-50 text-primary-600" : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100">
                  <i className="ri-home-line text-lg"></i>
                </div>
                Главная
              </Link>
              <Link
                to="/yoybuy-spreadsheet-guide"
                className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === "/yoybuy-spreadsheet-guide" ? "bg-primary-50 text-primary-600" : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100">
                  <i className="ri-book-open-line text-lg"></i>
                </div>
                Руководство по шоппингу
              </Link>

              <button
                onClick={() => setCatOpen(!catOpen)}
                className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-xl text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100">
                    <i className="ri-grid-line text-lg"></i>
                  </div>
                  Категории товаров
                </div>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full bg-background-100 transition-transform ${catOpen ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>

              {catOpen && (
                <div className="pl-14 space-y-1">
                  {categories.map((cat) => (
                    <a
                      key={cat.key}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      <div className="w-7 h-7 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-600">
                        <i className={`${cat.icon} text-xs`}></i>
                      </div>
                      <span className="whitespace-nowrap">{cat.name}</span>
                      <i className="ri-arrow-right-up-line text-foreground-400 text-xs ml-auto"></i>
                    </a>
                  ))}
                </div>
              )}

              <div className="border-t border-background-200/70 my-2"></div>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 px-4 py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/20">
                  <i className="ri-shopping-cart-line text-lg"></i>
                </div>
                Купить сейчас
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 px-4 py-3 rounded-xl border-2 border-primary-500 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-50">
                  <i className="ri-external-link-line text-lg"></i>
                </div>
                Yoybuy Sheet
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}